import { init } from "@dash0/sdk-web";
import appPackage from "@appSrc/../package.json";
import { CONFIG } from "@shared/config";

const { VITE_DASH0_AUTH_TOKEN, VITE_DASH0_URL, MODE, DEV } = import.meta.env;

const {
  application: {
    initialization: {
      tracking: { isDash0Enabled },
    },
  },
} = CONFIG;

const domains = [/.*chargetrip\.io.*/, /.*chargetrip\.dev.*/];

export const initDash0 = (): void => {
  if (DEV || !isDash0Enabled) return;

  const isStagingEnvironment = MODE === "staging";

  init({
    serviceName: appPackage.name,
    propagators: [{ type: "traceparent", match: domains }],
    endpoint: {
      url: VITE_DASH0_URL,
      authToken: VITE_DASH0_AUTH_TOKEN,
    },
    enableTransportCompression: false,
    additionalSignalAttributes: {
      environment: isStagingEnvironment ? "staging" : "production",
    },
  });
};
